import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './banner-carousel.css';
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';

function BannerCarousel({ data }) {
  const navigate = useNavigate();

  const PrevArrow = ({ onClick }) => (
    <Box
      onClick={onClick}
      className="prev-arrow"
      sx={{
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        cursor: "pointer"
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
        <path d="M0.5 9.5L14 1L9 9L14 17.5L0.5 9.5Z" stroke="#E4535F" strokeLinejoin="round" />
      </svg>
    </Box>
  );

  const NextArrow = ({ onClick }) => (
    <Box
      onClick={onClick}
      className="next-arrow"
      sx={{
        position: "absolute",
        right: "-30px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        cursor: "pointer"
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
        <path d="M14.5 8.5L1 17L6 9L1 0.5L14.5 8.5Z" stroke="#E4535F" strokeLinejoin="round" />
      </svg>
    </Box>
  );

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 10000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    dotsClass: 'slick-dots custom-dots',
    fade: true,
    pauseOnHover: false
  };

  const handleClick = (link) => {
    if (link) {
      navigate(link);
    }
  }

  return (
    <div className={`banner-carousel`}>
      <Slider {...settings}>
        {data.map((item, index) => (
          <div key={index} className={`banner-slide ${item.customClass}`}>
            <img className="banner-image" src={item.image} alt={item.title} />
            <div className="banner-overlay">
              <Box className="banner-product-square">
                <Box className="banner-product-square-content">
                  <Box className="banner-product-square-content--wrapper">
                    <Typography
                      variant='h3'
                      className="banner-product-square-title"
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      className="banner-product-square-description"
                    >
                      {item.description}
                    </Typography>
                    {item.buttonText && (
                      <Button
                        variant="contained"
                        className="banner-product-square-button"
                        onClick={() => handleClick(item.buttonLink)}
                      >
                        {item.buttonText}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default BannerCarousel;
